/**
 * Trial Ending Soon Reminder Modal
 *
 * Shown on launch when user is in trial with 1-3 days remaining.
 * Renders Practice or Clinician upgrade modal based on signup source
 * or practice trial status.
 */

import { ClinicianUpgradeModal } from '@/components/modal/clinician-modal/clinician-upgrade-modal';
import { PracticeUpgradeModal } from '@/features/settings/billing/components/practice-upgrade-modal';
import { useQueryUser } from '@/hooks/query/useQueryUser';
import { useQueuedModal } from '@/hooks/useQueuedModal';
import useReverseTrial from '@/hooks/useReverseTrial';
import { isAppleCompliantBuild } from '@/utils/appConfiguration';
import { ModalId, SignupSource } from '@heidi/schema/ml-scribe';

export const TrialEndingSoonReminderModal = () => {
  const { isOpen: isQueueOpen, handleClose: handleQueueClose } = useQueuedModal(
    ModalId.TRIAL_ENDING_SOON_REMINDER
  );
  const { data: signupSource } = useQueryUser(
    (u) => u?.signup_source ?? SignupSource.scribe
  );
  const { isPracticeTrialUser } = useReverseTrial();

  if (!isQueueOpen || isAppleCompliantBuild()) {
    return null;
  }

  if (signupSource === SignupSource.practice || isPracticeTrialUser) {
    return (
      <PracticeUpgradeModal launchOpen={isQueueOpen} onLaunchClose={handleQueueClose} />
    );
  }

  // Evidence signup + default: Clinician (Evidence Plus upgrade retired, GRO-3609)
  return (
    <ClinicianUpgradeModal launchOpen={isQueueOpen} onLaunchClose={handleQueueClose} />
  );
};
